<template>
  <div class="app-table-container">
    <!-- 查询条件 -->
    <el-form>
      <el-form-item label="名称" :label-width="formLabelWidth">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input v-model="queryForm.title" maxlength="9" size="small" placeholder="名称" />
          </el-col>
          <el-col :span="8">
            <el-button type="primary" size="small" @click="handlePage(1)">搜索</el-button>
            <el-button size="small" @click="reset()">重置</el-button>
          </el-col>
      </el-row>
      </el-form-item>
    </el-form>
    <!-- 数据表格 -->
    <el-table
      stripe
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      :data="tableData"
      :height="tableHeight"
      ref="tableContainer"
      class="table-container">
      <!-- <el-table-column
        fixed
        prop="orderInfo"
        min-width="80px"
        label="用户信息">
        <template slot-scope="scope">
          <div>ID：{{scope.row.creator?scope.row.creator.username:''}}</div>
          <div>昵称：{{scope.row.creator?scope.row.creator.name:''}}</div>
          <img style="width: 40px;" :src="scope.row.creator?scope.row.creator.avatarId:''"/>
        </template>
      </el-table-column>

      <el-table-column
        fixed
        prop="orderInfo"
        label="订单信息"
        min-width="140px" >
        <template slot-scope="scope">
          <div>订单ID：{{scope.row.orderId}}</div>
          <div>套餐：{{scope.row.setmeal?scope.row.setmeal.title:''}}</div>
          <div>店铺：{{scope.row.store?scope.row.store.storeName:''}}</div>
        </template>
      </el-table-column> -->

      <el-table-column
        fixed
        prop="title"
        label="名称"
        :show-overflow-tooltip="true"
        min-width="100px" />

      <el-table-column
        fixed
        prop="desc1"
        label="描述"
        :show-overflow-tooltip="true"
        min-width="100px" />

      <el-table-column
        fixed
        prop="fileNumber"
        label="数据集"
        :show-overflow-tooltip="true"
        min-width="50px">
          <template slot-scope="scope">
            <el-button type="warning" @click="handleTask('chapter', scope.row)" size="mini" round> {{scope.row.fileNumber}} </el-button>
          </template>
        </el-table-column>

<!--      <el-table-column
        prop="articleState"
        label="文件状态"
        min-width="80px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.articleState=='SUBMITTED'" type="danger" size="mini" round> {{scope.row.articleStateLabel}} </el-button>
          <el-button v-else-if="scope.row.articleState=='FAILED'" type="danger" size="mini" round> {{scope.row.articleStateLabel}} </el-button>
          <el-button v-else-if="scope.row.articleState=='STARTING'" type="warning" size="mini" round> {{scope.row.articleStateLabel}} </el-button>
          <el-button v-else-if="scope.row.articleState=='COMPLETED'" type="success" size="mini" round> {{scope.row.articleStateLabel}} </el-button>
          <el-button v-else type="info" size="mini" round> {{scope.row.articleStateLabel}} </el-button>
        </template>
      </el-table-column> -->
<!--
      <el-table-column
        prop="publishFlag"
        label="发布状态"
        min-width="80px">
        <template slot-scope="scope">
          <el-button @click="$permits.has(targetPermit,$permits.CREATE)?handlePublish(scope.row):''"  :type="scope.row.publishFlag?'success':'info'" size="mini" round>
            {{scope.row.publishFlag?'已发布':'未发布'}}
          </el-button>
        </template>
      </el-table-column> -->

<!--      <el-table-column
        prop="publishTime"
        label="发布时间"
        min-width="90px"/> -->

      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="90px"/>

      <el-table-column fixed="right" min-width="200px">
        <template slot="header">
          <span style="float: left">操作</span>
          <el-button
              style="float: right;"
              type="primary" size="mini"
              v-show="$permits.has(targetPermit,$permits.CREATE)"
              @click="handleAction($permits.CREATE)">
            + 创建
          </el-button>
        </template>
        <template slot-scope="scope">
          <!-- <el-button v-show="$permits.has(targetPermit,$permits.VIEW)" @click="handleAction($permits.VIEW,scope.row)" size="mini" type="success" round>数据集</el-button> -->
          <el-button v-show="$permits.has(targetPermit,$permits.UPDATE)" @click="handleAction($permits.UPDATE,scope.row)" size="mini" type="warning" round>编辑</el-button>
          <el-button v-show="$permits.has(targetPermit,$permits.REMOVE)" @click="handleRemove(scope.row)" size="mini" type="danger" round>删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <el-row>
      <el-col>
        <div class="pagination">
          <el-pagination background
            v-if="paginations.total>0"
            :page-sizes="paginations.pages"
            :page-size="paginations.size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page.sync="paginations.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </el-col>
    </el-row>
    <KnowledgeBaseForm v-if="control.show" :control="control" :enums="enums" />
    <ChapterPage v-if="controlChapter.show" :controlChapter="controlChapter" :enums="enums" />
  </div>
</template>
<script>

import * as EnumApi from '@/api/enums'
import * as KnowledgeBaseApi from '@/api/knowledgebase'
import KnowledgeBaseForm from './form'
import ChapterPage from './chapter/page.vue'
export default {
  name: 'KnowledgeBase',
  components: {
    KnowledgeBaseForm,ChapterPage
  },
  data() {
    return {
      formLabelWidth: '80px',
      enums: [],
    	targetPermit: 'knowledgebase',
      tableHeight: 0,
      queryForm: {
        name: '',
        current: '',
        size: ''
      },
      controlChapter : {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      control: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      tableData: [],
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 10, // 每页行数
        sizes: [10, 20, 30, 40], // 每页行数 调整
        layout: 'total, sizes, prev, pager, next, jumper' // 翻页属性
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.tableContainer.$el.offsetHeight;
    })
    this.handlePage()
    this.handleEnum()
  },
  methods: {
    // 重置
    reset() {
      Object.keys(this.queryForm).forEach(key => (this.queryForm[key] = ''))
      this.handlePage()
    },
    handleTask(action,item) {
      let that = this;
      console.log("handleTask action >> " + action)
      that.controlChapter.show = true;
      that.controlChapter.action = action;
      that.controlChapter.title = "章节";
      that.controlChapter.form = item;
    },
    handleAction(action,item) {
      let that = this;
      console.log("action >> " + action)
      that.control.show = true;
      that.control.disabled = false;
      that.control.action = action;

      switch(action){
        case that.$permits.VIEW:
          that.control.title = "详情";
          that.control.disabled = true;
          that.control.form = item;
          console.log("switch >>> " + that.$permits.VIEW)
          break;
        case that.$permits.UPDATE:
          that.control.title = "编辑";
          that.control.form = item;
          console.log("switch >>> " + that.$permits.UPDATE)
          break;
        case that.$permits.CREATE:
          that.control.title = "新建";
          console.log("switch >>> " + that.$permits.CREATE)
          break;
      }
    },
    handleRemove(item) {
      let that = this;
      that.$confirm('', '确定删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        KnowledgeBaseApi.remove(item.id).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handlePublish(item) {
      let that = this;
      let tip = !item.publishFlag?'发布':'取消发布'
      that.$confirm('', '确定'+tip+'吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        KnowledgeBaseApi.published({id: item.id, enabled: !item.publishFlag}).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handleEnum() {
      let that = this;
      // 获取表格数据
      EnumApi.list().then(res => {
        let result = res.data.data;
        that.enums = result
      })
    },
    handlePage(current) {
      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size
      // 获取表格数据
      KnowledgeBaseApi.page(that.queryForm).then(res => {
        let result = res.data.data;
        that.tableData = result.records
        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>

<style scoped lang="scss">
.el-drawer.rtl {
    right: 0;
    overflow-y: auto !important;
}
</style>
